<template>
    <div class="">
        <b-row class="justify-content-center">
            <h5>{{ labels.title }}</h5>
        </b-row>
        <!-- <pre>{{ infoConstante }}</pre> -->
        <div class="d-flex col-md-12 justify-content-center">
            <table style="border: 1px solid black;" class="tblEstandar">
                <tr style="border: 1px solid black; background-color: #2e507a; color: white;">
                    <th class="text-center">X</th>
                    <th class="text-center">Descripción</th>
                    <th class="text-center">Cifra</th>
                    <th class="text-center">Indice</th>
                </tr>
                <tr>
                    <td style="border: 1px solid black;">X1</td>
                    <td style="border: 1px solid black;">Activo corriente - Pasivo corriente</td>
                    <td style="border: 1px solid black;" class="text-right"> {{ calcActCorMenosPasCor(infoFinanciera.activo_corriente,infoFinanciera.pasivo_corriente) }} </td>
                    <td style="border: 1px solid black;"> {{ const_1(infoFinanciera.activo_corriente,infoFinanciera.pasivo_corriente,infoFinanciera.total_activo) }} </td>
                </tr>
                <tr>
                    <td style="border: 1px solid black;"></td>
                    <td style="border: 1px solid black;">Total activo</td>
                    <td style="border: 1px solid black;" class="text-right"> {{ formatNumber(infoFinanciera.total_activo) }} </td>
                    <td style="border: 1px solid black;"></td>
                </tr>
                <tr>
                    <td style="border: 1px solid black;">X2</td>
                    <td style="border: 1px solid black;">Utilidad acumulada</td>
                    <td style="border: 1px solid black;" class="text-right"> {{ formatNumber(infoFinanciera.utilidad_acumulada) }} </td>
                    <td style="border: 1px solid black;"> {{ const_2(infoFinanciera.utilidad_acumulada,infoFinanciera.total_activo) }} </td>
                </tr>
                <tr>
                    <td style="border: 1px solid black;"></td>
                    <td style="border: 1px solid black;">Total activo</td>
                    <td style="border: 1px solid black;" class="text-right"> {{ formatNumber(infoFinanciera.total_activo) }} </td>
                    <td style="border: 1px solid black;"></td>
                </tr>
                <tr>
                    <td style="border: 1px solid black;">X3</td>
                    <td style="border: 1px solid black;">EBIT</td>
                    <td style="border: 1px solid black;" class="text-right"> {{ formatNumber(infoFinanciera.ebit) }} </td>
                    <td style="border: 1px solid black;"> {{ const_3(infoFinanciera.ebit,infoFinanciera.total_activo) }} </td>
                </tr>
                <tr>
                    <td style="border: 1px solid black;"></td>
                    <td style="border: 1px solid black;">Total activo</td>
                    <td style="border: 1px solid black;" class="text-right"> {{ formatNumber(infoFinanciera.total_activo) }} </td>
                    <td style="border: 1px solid black;"></td>
                </tr>
                <tr>
                    <td style="border: 1px solid black;">X4</td>
                    <td style="border: 1px solid black;">Patrimonio</td>
                    <td style="border: 1px solid black;" class="text-right"> {{ formatNumber(infoFinanciera.total_patrimonio) }} </td>
                    <td style="border: 1px solid black;"> {{ const_4(infoFinanciera.total_patrimonio,infoFinanciera.total_pasivo) }} </td>
                </tr>
                <tr>
                    <td style="border: 1px solid black;"></td>
                    <td style="border: 1px solid black;">Pasivo</td>
                    <td style="border: 1px solid black;" class="text-right"> {{ formatNumber(infoFinanciera.total_pasivo) }} </td>
                    <td style="border: 1px solid black;"></td>
                </tr>
                <tr>
                    <td style="border: 1px solid black;"></td>
                    <td style="border: 1px solid black;">Score</td>
                    <td style="border: 1px solid black;"></td>
                    <td style="border: 1px solid black;"> {{const_5(infoFinanciera.activo_corriente,infoFinanciera.pasivo_corriente,infoFinanciera.total_activo,infoFinanciera.utilidad_acumulada,infoFinanciera.total_patrimonio,infoFinanciera.total_pasivo,infoFinanciera.ebit,infoConstante.vigencia)}} </td>
                </tr>
                <tr>
                    <td style="border: 1px solid black;"></td>
                    <td style="border: 1px solid black;">Calificación</td>
                    <td style="border: 1px solid black;"></td>
                    <!-- <td style="border: 1px solid black;"> {{ calificacion(infoFinanciera.activo_corriente,infoFinanciera.pasivo_corriente,infoFinanciera.total_activo,infoFinanciera.utilidad_acumulada,infoFinanciera.total_patrimonio,infoFinanciera.total_pasivo,infoFinanciera.ebit,infoConstante.vigencia) }} </td> -->
                    <td style="border: 1px solid black;"> {{ calificacion() }} </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import Calificacion from '../../../services/Calificacion';
import Score from '../../../services/Score';

export default {
    name : 'Cifras',
    props : ['infoFinanciera','infoConstante','saveScore'],
    data: () => ({
        qlity : '',
        rslCalificacion : '',
        constX1 : null,
        constX2 : null,
        constX3 : null,
        constX4 : null,
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title : 'Score',
                    save : 'Guardar',
                    close : 'Cerrar',
                    editar : 'Editar',
                    cifras : 'Cifras',
                }
            }else{
                return {
                    title : 'Score',
                    save : 'Save',
                    close : 'Close',
                    editar : 'Edit',
                    cifras : 'Figures',
                }
            }
        }
    },
    methods:{
        calcActCorMenosPasCor(activo_corriente,pasivo_corriente){
            const resultado = activo_corriente - pasivo_corriente
            return this.formatNumber(resultado)
        },
        const_1(activo_corriente,pasivo_corriente,total_activo){
            let resta = activo_corriente - pasivo_corriente
            let result = (resta/total_activo) * this.infoConstante.constante_1
            this.constX1 = result.toFixed(2)
            return result.toFixed(2)
        },
        const_2(utilidad_acumulada,total_activo){
            let ope = utilidad_acumulada / total_activo
            let result = ope * this.infoConstante.constante_2
            this.constX2 = result.toFixed(2)
            return result.toFixed(2)
        },
        const_3(ebit,total_activo){
            let ope = ebit / total_activo
            let result = ope * this.infoConstante.constante_3
            this.constX3 = result.toFixed(2)
            return result.toFixed(2)
        },
        const_4(total_patrimonio,total_pasivo){
            let ope = total_patrimonio / total_pasivo
            let result = ope * this.infoConstante.constante_4
            this.constX4 = result.toFixed(2)
            return result.toFixed(2)
        },
        const_5(activo_corriente,pasivo_corriente,total_activo,utilidad_acumulada,total_patrimonio,total_pasivo,ebit){
            let resta = activo_corriente - pasivo_corriente
            let constX1 = (resta/total_activo) * this.infoConstante.constante_1
            // console.log(constX1);
            let constX2 = (utilidad_acumulada / total_activo) * this.infoConstante.constante_2
            // console.log(constX2);
            let constX3 = (ebit / total_activo) * this.infoConstante.constante_3
            // console.log(constX3);
            let constX4 = (total_patrimonio / total_pasivo) * this.infoConstante.constante_4
            // console.log(parseFloat(this.infoConstante.score,10));
            let result = constX1 + constX2 + constX3 + constX4 + parseFloat(this.infoConstante.score,10)
            let calificacion = result.toFixed(2)
            this.qlity = calificacion
            return calificacion
        },
        calificacion(){
            // console.log(this.infoFinanciera.vigencia,this.qlity);
            Calificacion.calificacionByVigenciaAndCalificacion(this.infoFinanciera.vigencia,this.qlity)
            .then((res) => {
                // console.log(res.data.calificaByVigCalifi);
                this.rslCalificacion = res.data.calificaByVigCalifi[0].calificacion
            })
            .catch((err) => console.log(err))
            return this.rslCalificacion
        },
        formatNumber(value) {
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(value);
        },
    },
    updated(){
        const info = {
            'vigencia' : this.infoFinanciera.vigencia,
            'activoCorriente_PasivoCorriente' : this.infoFinanciera.activo_corriente - this.infoFinanciera.pasivo_corriente,
            'total_activo' : this.infoFinanciera.total_activo,
            'utilidad_acumulada' : this.infoFinanciera.utilidad_acumulada,
            'ebit' : this.infoFinanciera.ebit,
            'patrimonio' : this.infoFinanciera.total_patrimonio,
            'pasivo' : this.infoFinanciera.total_pasivo
        }

        Score.createScoreCifras(info)
        .then((res) => {
            if(res.status == 201){
                this.$toast.success(res.data.message)
            }
        })
        .catch((err) => console.log(err))

        const data = {
            'vigencia' : this.infoFinanciera.vigencia,
            'x1' : this.constX1,
            'x2' : this.constX2,
            'x3' : this.constX3,
            'x4' : this.constX4,
            'score' : this.qlity,
            'calificacion' : this.rslCalificacion
        }

        Score.createScoreX(data)
        .then((res) => {
            if(res.status == 201){
                this.$toast.success(res.data.message)
            }
        })
        .catch((err) => console.log(err))
    }
}
</script>

<style>

</style>